import { Stack } from "@mui/material";
import React from "react";

import '../../css/App.css';
import SeatDetail from "./SeatDetail";
import ContextMenuButton from "./ContextMenuButton";

export default function SessionBriefDetails({ session, contextId, onContextMenuClick, options }) {
    return (
        <Stack id={contextId} direction="row" justifyContent={"flex-start"} sx={{zIndex: 1}}>
            { options.enableContextMenu
              && <ContextMenuButton id={contextId} onContextMenuClick={onContextMenuClick} /> }

            <SeatDetail session={session} compactView={false} />
        </Stack>
    );
}
